import { cn } from "@/lib/utils";
import { ReactNode } from "react";

type CardErrorProps = {
    children: ReactNode;
    icon: ReactNode;
    className?: string;
};

const CardError: React.FC<CardErrorProps> = ({ children, icon, className }) => {
    return (
        <div
            className={cn(
                "CardError | ",
                "w-full rounded-[14px] border border-whiteShade-65 bg-red-cancel shadow-card-error-320",
                "2xs:shadow-card-error-480 2xs:backdrop-blur-[71px]",
                "4k:rounded-[56px]",
                className,
            )}
        >
            <div
                className={cn(
                    "flex w-full items-center justify-center gap-[10px] rounded-[14px] bg-whiteShade-10 px-[20px] py-[18px]",
                    "2xs:px-[24px]",
                    "4k:gap-[40px] 4k:rounded-[56px] 4k:px-[80px] 4k:py-[72px]"
                )}
            >
                <div
                    className={cn(
                        "relative h-[28px] max-h-[28px] min-h-[28px] w-[28px] min-w-[28px] max-w-[28px]",
                        "2xs:h-[33px] 2xs:max-h-[33px] 2xs:min-h-[33px] 2xs:w-[33px] 2xs:min-w-[33px] 2xs:max-w-[33px]",
                        "4k:h-[132px] 4k:max-h-[132px] 4k:min-h-[132px] 4k:w-[132px] 4k:min-w-[132px] 4k:max-w-[132px]",
                    )}
                >
                    {icon}
                </div>
                <div className={cn("font-frutigerBold text-[12px] tracking-minus-2", "2xs:text-[16px]", "4k:text-[48px]")}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CardError;
